import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { MaskedLines, FadeUp, EASE } from "@/components/motion";
import { CTAButton } from "@/components/CTA";
import { FAQS } from "@/data/faqs";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <main data-testid="page-faq" className="pt-40 lg:pt-48">
      <header className="mx-auto max-w-[1500px] px-6 lg:px-12 pb-20 lg:pb-28">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-mono text-[11px] tracking-[0.4em] text-glow/80 mb-8"
        >
          ANTES DEL ALTA
        </motion.p>
        <h1 className="font-display font-800 uppercase leading-[0.95] tracking-tight text-[11vw] sm:text-7xl lg:text-8xl text-offwhite">
          <MaskedLines
            mode="load"
            delay={0.3}
            lines={[
              <span key="a">Preguntas</span>,
              <span key="b" className="font-cormorant normal-case font-medium text-metal">frecuentes.</span>,
            ]}
          />
        </h1>
      </header>

      <section className="mx-auto max-w-[1100px] px-6 lg:px-12 pb-28">
        {FAQS.map((f, i) => (
          <FadeUp key={f.q} delay={Math.min(i * 0.04, 0.3)} y={20}>
            <div className="border-b border-silver/10" data-testid={`faq-item-${i + 1}`}>
              <button
                data-testid={`faq-question-${i + 1}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                aria-expanded={open === i}
                className="w-full flex items-center justify-between gap-8 py-7 text-left group"
              >
                <span className="flex items-baseline gap-5">
                  <span className="font-mono text-[10px] text-steel hidden sm:block">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span
                    className={`font-display font-700 text-lg sm:text-2xl tracking-tight transition-colors duration-300 ${
                      open === i ? "text-offwhite" : "text-mist group-hover:text-silver"
                    }`}
                  >
                    {f.q}
                  </span>
                </span>
                <motion.span
                  animate={{ rotate: open === i ? 45 : 0 }}
                  transition={{ duration: 0.35, ease: EASE }}
                  className="shrink-0 text-steel group-hover:text-silver transition-colors duration-300"
                >
                  <Plus className="h-5 w-5" strokeWidth={1.5} />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.45, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <p
                      className="pb-8 pl-0 sm:pl-10 text-mist leading-relaxed max-w-2xl"
                      data-testid={`faq-answer-${i + 1}`}
                    >
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </FadeUp>
        ))}

        <FadeUp delay={0.1} className="mt-20 flex flex-wrap items-center justify-between gap-8 border border-silver/15 bg-panel/40 p-9">
          <div>
            <p className="font-oswald font-600 uppercase text-2xl tracking-wide text-offwhite mb-2">
              ¿Todo claro?
            </p>
            <p className="text-mist text-sm">Tu comercio puede estar protegido desde hoy.</p>
          </div>
          <CTAButton testid="faq-cta-alta">DARME DE ALTA</CTAButton>
        </FadeUp>
      </section>
    </main>
  );
}
